import { FC } from 'react';
import { Stack, Theme } from '@mui/material';
import { createUseStyles } from 'react-jss';
import Menu from '../menu';
import MenuItem from '../menu/menu-item';
import Icon from '../icon';
import Text from '../text';
import useIntercom from '@/hooks/use-intercom.hook';
import { openNewTab } from '@/lib/url-helpers';
import { HELP_CENTER_URL } from './helpers';

const useStyles = createUseStyles((theme: Theme) => ({
  trigger: {
    color: theme.palette.darkGray,
    '& .MuiSvgIcon-root': {
      color: 'inherit',
    },
    '&:hover': {
      color: theme.palette.surface.primary.main,
    },
  },
}));

const SupportMenu: FC = () => {
  const styles = useStyles();
  const { show: showIntercom } = useIntercom();

  const handleHelpCenter = () => {
    openNewTab(HELP_CENTER_URL);
  };

  const TriggerEl = (
    <Stack direction="row" alignItems="center" gap={0.5} className={styles.trigger}>
      <Icon name="help" size="small" />
      <Text size="small" noWrap>
        Support
      </Text>
      <Icon name="expand" size="small" />
    </Stack>
  );

  return (
    <Menu menuId="support-menu" trigger={TriggerEl}>
      <MenuItem label="Help Center" icon="open-in-new" onClick={handleHelpCenter} />
      <MenuItem label="Chat with Support" icon="chat" onClick={showIntercom} />
    </Menu>
  );
};

export default SupportMenu;
